import { ApiResponse, isSuccessful } from './api-requests';
import { Tooltip_t, tooltips } from '../components/common/tooltips/tooltips';
import { NavigationProp } from '@react-navigation/native';
import { notificationService } from './notification-service';
import { Platform, Linking } from 'react-native';
import { generateAuthToken } from './user-session-service';

export function generateRegistrationPopup(
  userInfo: ApiResponse<any>,
  chargerCount: number,
  price: number,
  closePopup: () => void,
  navigation: NavigationProp<any>
) {
  let text: Tooltip_t | null = null;
  let buttons: Array<{ text: string; onPress: () => void }> = [];
  const tasks = userInfo.payload?.user?.onboarding_tasks ?? [];
  const total = (chargerCount * price).toFixed(2);

  if (isSuccessful(userInfo.status)) {
    // Scenario 1: incomplete tasks but billing complete
    if (tasks.length > 0 && !tasks.includes('SETUP_CHARGER_SUBSCRIPTION')) {
      text = {
        ...tooltips.onboardingTasksIncompleteBillingComplete,
        text: `${tooltips.onboardingTasksIncompleteBillingComplete.text}$${total}`,
      };
      buttons = [
        {
          text: 'Cancel',
          onPress: () => {
            closePopup();
            navigation.navigate('MyChargers');
          },
        },
        {
          text: 'Onboarding',
          onPress: () => {
            closePopup();
            navigation.navigate('OnboardingStatus');
          },
        },
      ];
    }
    // Scenario 2: billing not complete
    else if (tasks.length > 0) {
      text = {
        ...tooltips.onboardingBillingNotComplete,
        text: `${tooltips.onboardingBillingNotComplete.text}$${total}`,
      };
      buttons = [
        {
          text: 'Billing',
          onPress: async () => {
            closePopup();
            if (Platform.OS === 'web') {
              navigation.navigate('SetupBilling', { returnToOnboarding: true });
            } else {
              // For mobile, generate a secure single-use token and redirect to web
              try {
                const tokenResponse = await generateAuthToken();
                
                if (isSuccessful(tokenResponse.status) && tokenResponse.payload?.token) {
                  const webOnboardingUrl = `${process.env.REACT_NATIVE_API_SERVER}/onboardingstatus?authToken=${tokenResponse.payload.token}`;
                  
                  await Linking.openURL(webOnboardingUrl);
                  
                  // Optionally show success message
                  notificationService.sendNotification(
                    'info',
                    'Opening billing setup in browser...'
                  );
                } else {
                  throw new Error('Failed to generate authentication token');
                }
              } catch (err) {
                console.error('Failed to generate auth token or open URL:', err);
                notificationService.sendNotification(
                  'error',
                  'Failed to open billing setup. Please try again.'
                );
              }
            }
          },
        },
        {
          text: 'Onboarding',
          onPress: () => {
            closePopup();
            navigation.navigate('OnboardingStatus');
          },
        },
        {
          text: 'Cancel',
          onPress: () => {
            closePopup();
            navigation.navigate('MyChargers');
          },
        },
      ];
    }
    // Scenario 3: all tasks complete
    else if (tasks.length === 0) {
      text = {
        ...tooltips.onboardingTasksComplete,
        text: `${tooltips.onboardingTasksComplete.text}$${total}`,
      };
      buttons = [
        {
          text: 'Cancel',
          onPress: () => {
            closePopup();
            navigation.navigate('MyChargers');
          },
        },
        {
          text: 'I Accept',
          onPress: () => {
            closePopup();
            navigation.navigate('MyChargers');
          },
        },
      ];
    }
  } else {
    // Scenario 4: unknown
    // unknown scenario
    notificationService.sendNotification(
      'error',
      'Unknown User or Charger Status'
    );
  }

  return { text, buttons };
}
